import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'credits',
})
export class CreditsPipe implements PipeTransform {
  transform(value: number): string {
    return Number.isInteger(value) ? `${value}` : value.toFixed(1);
  }
}
